import React, { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import PreLoader from './components/others/PreLoader';

// Lazy load route components for code splitting
const Home1 = lazy(() => import('./pages/homePages/Home1'));
const Home2 = lazy(() => import('./pages/homePages/Home2'));
const About = lazy(() => import('./pages/innerPages/About'));
const Services = lazy(() => import('./pages/innerPages/Services'));
const ServiceDetails = lazy(() => import('./pages/innerPages/ServiceDetails'));
const Projects = lazy(() => import('./pages/innerPages/Projects'));
const ProjectDetails = lazy(() => import('./pages/innerPages/ProjectDetails'));
const Blog = lazy(() => import('./pages/innerPages/Blog'));
const BlogDetails = lazy(() => import('./pages/innerPages/BlogDetails'));
const Contact = lazy(() => import('./pages/innerPages/Contact'));
const Team = lazy(() => import('./pages/innerPages/Team'));
const TeamDetails = lazy(() => import('./pages/innerPages/TeamDetails'));

const Routers = () => {
    return (
        <Suspense fallback={<PreLoader />}>
            <Routes>
                <Route path='/' element={<Home1 />}></Route>
                {/* <Route path='/home-2' element={<Home2 />}></Route> */}
                <Route path='/about' element={<About />}></Route>
                {/* <Route path='/services' element={<Services />}></Route> */}
                <Route path='/service-details/:slug' element={<ServiceDetails />}></Route>
                <Route path='/projects' element={<Projects />}></Route>
                <Route path='/project-details/:id' element={<ProjectDetails />}></Route>
                {/* <Route path='/blog' element={<Blog />}></Route>
                <Route path='blog-details/:id' element={<BlogDetails />}></Route> */}
                <Route path='/contact' element={<Contact />}></Route>
                <Route path='/team' element={<Team />}></Route>
                <Route path='/team-details/:id' element={<TeamDetails />}></Route>
            </Routes>
        </Suspense>
    );
};

export default Routers;